<template>
  <div class="srm-client-scroll">
    <el-carousel indicator-position="none" arrow="always" :interval="5000">
      <el-carousel-item v-for="item in testimonialsCon" :key="item.id">
        <div class="rel carousel-content">
          <div class="abs carousel-img-video cp" v-if="item.video_link"
               @click="openVideoPlayer(item.video_link)">
            <img :class="item.logo?'has-logo':''" src="../../assets/img/index/video.png" alt="logo"/>
          </div>
          <div class="abs logo-img cp" :class="item.video_link?'has-video':''" v-if="item.logo">
            <img v-lazy="$global.globalPath + item.logo" alt="logo">
          </div>
          <div class="abs carousel-img cp" v-if="item.video_link">
            <img v-lazy="$global.globalPath + item.img" alt="logo">
          </div>
          <div class="abs carousel-img" v-if="!item.video_link">
            <img v-lazy="$global.globalPath + item.img" :alt="item.img">
          </div>
          <div class="abs carousel-desc">
            <div class="carousel-desc-w">
              <div class="deco_icon">“</div>
              <!-- <div class="tl ellipse title">{{item.source}}</div> -->
              <p class="tl desc">
                {{item.speech}}
              </p>
              <h1 class="tr company-name"> —{{item.name}}</h1>
              <p class="link"><a class="link" @click="goConsult()" href="#">咨询案例详情 > </a></p>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!--视频弹窗-->
    <div class="index-video">
      <el-dialog
        custom-class="customClass"
        :visible.sync="centerDialogVisible"
        width="800px"
        @close="closeVideoDialog">
        <div class="video-test">
          <div class="video-img tc cp" v-show="showVideoImg" @click.stop.prevent="videoPlay">
            <h1 class="video-title dib">{{videoText}}</h1>
          </div>
          <div class="homeDialog-video" @click.stop.prevent="videoClick">
            <video :src="videoPlayData" id="homeVideo"
                   @seeked="videoSeek" @pause="videoClick"
                   @error="videoError" @ended="videoDown"
                   preload="auto" controls autoplay controlsList="nodownload">
            </video>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['openRegister', 'goConsult'],
  name: 'speechSwiper',
  data () {
    return {
      videoText: '点击开始播放',
      testimonialsCon: [],
      loading: false,
      centerDialogVisible: false,
      showVideoImg: false,
      videoPlayData: {}
    }
  },
  props: {
    mark: {
      type: Number,
      default: 1
    }
  },
  created () {
    this.getTestimonialsData()
  },
  methods: {
    openVideoPlayer (data) {
      this.videoPlayData = {}
      this.centerDialogVisible = true
      this.showVideoImg = false
      this.videoPlayData = data
      this.$nextTick(() => {
        let videoDom = document.getElementById('homeVideo')
        videoDom.disablePictureInPicture = true
        videoDom.play()
      })
    },
    getTestimonialsData () {
      this.$api.post('/index/home_speech', { 'mark': this.mark }, r => {
        if (r.code === 0) {
          this.testimonialsCon = r.data
          this.loading = true
        } else {
          this.$message.error(r.message)
        }
      })
    },
    closeVideoDialog () {
      let videoDom = document.getElementById('homeVideo')
      this.videoText = '点击开始播放'
      this.showVideoImg = false
      videoDom.load()
      videoDom.pause()
    },
    videoSeek () {
      let videoDom = document.getElementById('homeVideo')
      if (videoDom.played) {
        this.showVideoImg = false
      }
    },
    videoClick () {
      let videoDom = document.getElementById('homeVideo')
      if (videoDom.error) {
        return false
      }
      if (videoDom.played) {
        this.videoText = '点击继续播放'
        videoDom.pause()
        this.showVideoImg = true
      } else {
        videoDom.play()
        this.showVideoImg = false
      }
    },
    videoPlay () {
      let videoDom = document.getElementById('homeVideo')
      if (videoDom.error) {
        return false
      }
      if (videoDom.paused) {
        videoDom.play()
        this.showVideoImg = false
      } else {
        videoDom.pause()
        this.showVideoImg = true
      }
    },
    videoDown () {
      this.videoText = '点击开始播放'
      this.showVideoImg = true
    },
    videoError () {
      this.videoText = '视频文件加载错误'
    }
  }
}
</script>

<style lang="scss">
  .srm-client-scroll {
    margin: 25px -40px 80px -40px;
    height: 310px;

    .el-carousel {
      width: 1300px;
    }

    .el-carousel__container {
      height: 350px;
    }

    .el-carousel__arrow--right {
      right: 4px;
    }

    .el-carousel__arrow--left {
      left: 4px;
    }

    .el-carousel__arrow {
      background: #929AA9;
      border-radius: 2px;
      width: 28px;
      height: 28px;
    }

    .el-carousel__item {
      position: absolute;
      width: 1200px;
      margin: 0 auto;
      left: 0;
      right: 0;
      overflow: initial;

      .carousel-content {
        margin: 15px auto 0 auto;
        /*box-shadow: 0 3px 10px 0 rgba(40, 41, 41, 0.2);*/
        height: 310px;

        .carousel-img {
          // top: 20px;
          left: 0;
          width: 600px;
          height: 310px;
          z-index: 10;

          img {
            width: 100%;
            height: 100%;
            // border-radius: 5px;
          }
        }

        .logo-img {
          left: 150px;
          top: 115px;
          width: 180px;
          height: 45px;
          z-index: 11;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .has-video {
          left: 160px;
          top: 85px;
        }

        .carousel-img-video {
          background-color: #000;
          opacity: 0.6;
          left: 0;
          width: 600px;
          height: 310px;
          z-index: 11;

          img {
            width: 40px;
            margin-left: 280px;
            margin-top: 135px;
          }

          .has-log {
            margin-top: 130px;
          }
        }

        .carousel-desc {
          z-index: 8;
          right: 0;
          width: 600px;
          height: 310px;
          background: #FAFAFA;
          border: 1px solid #f2f2f2;

          .carousel-desc-w {
            margin: 62px 36px 0 74px;

            .title {
              margin-top: 50px;
              font-size: 14px;
              color: #666;
              font-weight: bold;
            }

            .deco_icon {
              position: absolute;
              left: 28px;
              font-size: 80px;
              top: 48px;
              color: #29BECE;
            }

            .desc {
              width: 490px;
              font-size: 14px;
              color: #10263D;
              line-height: 22px;
              /*overflow: hidden;*/
              /*text-overflow: ellipsis;*/
              /*display: -webkit-box;*/
              /*-webkit-line-clamp: 3;*/
              /*-webkit-box-orient: vertical;*/
            }

            .company-name {
              margin-top: 20px;
              font-size: 14px;
              color: #929AA9;
              margin-bottom: 20px;
            }

            .link {
              width: 490px;

              a {
                font-size: 14px;
                color: #29BECE;
                letter-spacing: 0;
              }
            }
          }
        }
      }
    }
  }

  .index-video {
    .customClass {
      //height: 450px;
      background: #000;
      border-radius: 3px;

      .el-dialog__headerbtn {
        z-index: 11;
      }

      .el-dialog__close {
        color: #fff;
        font-size: 24px;
      }

      .video-test {
        position: relative;
        user-select: none;
        height: 100%;

        .video-img {
          z-index: 10;
          position: absolute;
          // background: rgba(19, 18, 18, 0.5);
          background-color: #000;
          opacity: 0.5;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          height: 100%;

          .video-title {
            color: #ffffff;
            font-size: 24px;
            position: relative;
            top: calc(50% - 24px);
          }
        }
      }

      .el-dialog__header, .el-dialog__body {
        padding: 0;
      }

      .homeDialog-video {
        width: 100%;
        height: 100%;

        video {
          width: 100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// speechSwiper.vue?4960e5c7